import {city} from './city';
export class state{

      constructor(public statecode: string,  
                 public name: string,
                 public countryid: string,
                 public CountryCity:city[]) { }

}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/_common/countrylist/state.ts